//#region Angular Imports

import { StateService } from "@uirouter/angularjs"

//#endregion

//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

//#region DevExtreme Imports

import 'devextreme/ui/date_box'

//#endregion

import Apimodelsssrs = require("../api/api.models.ssrs")
import Format = Apimodelsssrs.Format;

import { Api, LocalDictionaryFactory } from "./../api/api.module"
import { ColumnModel } from './../api/api.models'
import { GeneratedReportModel, SsrsReportRequestModel } from "../api/api.models"
import { ReportExportResult, ReportParameterInfo, ParameterTypeEnum, ReportType } from "../api/api.models.ssrs"

import { Activity } from '../../models/common/activity'

import { BaseGridController, ScopeBaseGrid } from "../common/common.base.grid.controller"
import { ButtonsOptions, GridController, GridOptions, GridTypes } from "../common/grid/grid.controller"
import { CreateEditInitParams, BulkEditInitParams } from '../common/create-edit-popup/create-edit-popup.controller'
import { DetailsOptions } from './../common/details-popup/details-popup.directive'
import { LoggerService } from "./../common/common.module"
import { i18n } from "../common/i18n/common.i18n"

import { CommonHelper } from "../../helpers/common-helper"
import { EventsNames } from "../../helpers/events-names"
import { IUserSession } from '../../helpers/user-session'
import { LocalizationHelper } from "../../helpers/localization-helper"
import { Permissions } from "../../helpers/permissions"

import { Enums } from '../../models/common/enums'
import { OpReport } from "../../models/dw/op-report"
import { StoredProcedureReportPopupForm, StoredProcedureReportPopupFormInitializedArgs, StoredProcedureReportPopupFormOptions } from "./custom/stored-procedure-report"

import { GridContextMenuService } from '../../services/grid'
import { SystemService } from "../../services/system";

import { ReportHelper } from './reports.helper'

import './ssrsraport-modal.scss';

interface IReportsScope extends ScopeBaseGrid {
    deleteConfirmationOptions: {
        title: string

        onConfirmed: () => void
    }

    mainGridOptions: GridOptions;
    id: number;
    ssrsReport: string;
    ssrsToolbar: string;
    currentPage: number;
    totalPages: number;
    searchText: string;
    subreportId: string;
    reportUrl: string;
    parameters: ReportParameterInfo[];
    mainReportParameters: ReportParameterInfo[];
    raportName: string;
    ssrsParametersHtml: string;
    closeModal: Function;
    refresh: Function;
    changePage: Function;
    printSsrsRaport: Function;
    generateFile: Function;
    findText: Function;
    clearSearch: Function;
    clearInput: Function;
    navigateToSubreport: Function;
    navigateToMainReport: Function;
    removeElementFromList: Function;
    stopPropagation: Function;
    mParameterTypeEnum: any;
    formatDate: Function;
    inputMultiParameterChangeValidate: Function;
    checkAllValueInInputMultiParameter: Function;
    inputDateValueChange: Function;
    inputCheckboxValueChange: Function;
    checkboxDefaultValue: Function;
    printWindow: Window;
    showOrHideToolTip: Function;
    showToolTip: boolean;
    formatCsv: boolean;
    formatExcel: boolean;
    formatMhtml: boolean;
    formatPdf: boolean;
    formatTiff: boolean;
    formatWord: boolean;
    formatXml: boolean;
    validatePageAndRefreshReport: Function;
    format: any;
    oldSearchText: string;
    setCorrectLanguage: Function;
    titleRefresh: string;
    titleRefreshParams: string;
    titlePrint: string;
    titleClose: string;
    titleExport: string;
    titleFirst: string;
    titlePrevious: string;
    titleNext: string;
    titleLast: string;
    titleSearch: string;
    titleBackToMain: string;
    viewReport: string;
    checkAll: string;
    isSubraport: boolean;
    goToMainReport: boolean;
    chooseOption: string;

    storedProcedureReportPopupFormOptions: StoredProcedureReportPopupFormOptions
    storedProcedureReportPopupForm: StoredProcedureReportPopupForm
}

export class ReportController extends BaseGridController {

    // Members

    private grid: GridController<OpReport>

    // Members End


    constructor(
        protected $scope: IReportsScope,
        protected $window: Window,
        $state: StateService,
        $timeout: ng.ITimeoutService,
        api: Api,
        private logger: LoggerService,
        localDictionary: LocalDictionaryFactory,
        private gridContextMenuService: GridContextMenuService,
        protected userSession: IUserSession,
        protected systemService: SystemService,
        referenceType: Enums.ReferenceType,
        private moduleName: Enums.SimaxModuleName
    ) {
        super($scope, $timeout, $state, userSession, systemService, api, localDictionary, null, referenceType);

        this.setEvents()
        this.setMainGridOptions()
        this.setConfirmationsOptions()

        this.setDefaultValuesOfProperties();

        $scope.storedProcedureReportPopupFormOptions = {
            onInitialized(e: StoredProcedureReportPopupFormInitializedArgs) {
                $scope.storedProcedureReportPopupForm = e.component
            },
        }

        /**
         * Set [selected_values] of multiple-valued [param] based on user interface.
         *
         * @param event - A click event on the parameter checkbox.
         * @param param - Current report parameter info object.  
         * @param changedValue - Changed value 
         * @returns {}
         * 
         */
        $scope.inputMultiParameterChangeValidate = (event: Event, param: ReportParameterInfo, changedValue: string) => {
            this.checkCorrectParameter(param, changedValue);
        }

        /**
         * Set all values of multiple-valued [param] based on user interface.
         *
         * @param event - A click event on the parameter checkbox.
         * @param param - Current report parameter info object.  
         * @returns {}
         * 
         */
        $scope.checkAllValueInInputMultiParameter = (event: Event, param: ReportParameterInfo) => {
            const idxallElements = (event.target as HTMLElement).parentElement.parentElement.children;
            const checkAll = (idxallElements[0] as HTMLElement).children[0] as HTMLInputElement;
            for (let i = 0; i < idxallElements.length; i++) {
                const inputCheckBox = (idxallElements[i] as HTMLElement).children[0] as HTMLInputElement;
                if (checkAll.checked !== inputCheckBox.checked && i !== 0) {
                    //inputCheckBox.checked = !inputCheckBox.checked;
                    this.checkCorrectParameter(param, param.validValues[i - 1].value);
                }
            }
        }

        /**
         * Set [selected_value] of date [param] based on user interface.
         * 
         * @param parameter - Current report parameter info object.
         * @param datePicker - Date Picker object.
         * @returns {} 
         */
        $scope.inputDateValueChange = (parameter: ReportParameterInfo, datePicker) => {
            const dateUs = new Date(datePicker.value).toLocaleString("en-US").replace(/,/g, "");
            parameter.selectedValues[0] = dateUs;
        }

        /**
         * Set [selected_value] of boolen [param] based on user interface.
         * 
         * @param parameter - Current report parameter info object.
         * @param checked - Checked flag.
         * @returns {} 
         */
        $scope.inputCheckboxValueChange = (parameter: ReportParameterInfo, checked: string) => {
            parameter.selectedValues[0] = checked;
        }

        /**
         * Refresh the report.
         * 
         * @param event - The cleck event.
         * @returns {} 
         */
        $scope.refresh = (event: Event) => {
            event.preventDefault();
            $scope.$root.$broadcast(EventsNames.SSRS_REPORT_RELOAD);
        }

        /**
         * Set default value of checkbox element based on parameter.
         * 
         * @param param - Current boolean report parameter info object.
         * @returns { True if parameter selected value is set to "true". Otherwise false.} 
         */
        $scope.checkboxDefaultValue = (param: ReportParameterInfo) => {

            if (param.selectedValues.length === 0)
                return false;

            return param.selectedValues[0].toLowerCase() === "true";
        }

        /**
         * Validates Current Page value in scope and call SSRS_REPORT_RELOAD event.
         * 
         * @returns {} 
         */
        $scope.validatePageAndRefreshReport = () => {
            if (this.$scope.currentPage > this.$scope.totalPages)
                this.$scope.currentPage = this.$scope.totalPages;
            else if (this.$scope.currentPage < 1)
                this.$scope.currentPage = 1;

            $scope.$root.$broadcast(EventsNames.SSRS_REPORT_RELOAD);
        }

        /**
         * Call SSRS_REPORT_PRINT event.
         * 
         * @param event - The click button event.
         * @returns {} 
         */
        $scope.printSsrsRaport = (event: Event) => {
            event.preventDefault();
            $scope.printWindow = window.open("", "_blank", "scrollbars=1,resizable=1,height=400,width=600");
            this.$scope.$root.$broadcast(EventsNames.SSRS_REPORT_PRINT);
        }

        /**
         * Set subreportId and call SSRS_REPORT_RELOAD event.
         * 
         * @param event - The click button event.   
         * @param url - The url of subreport in base64.
         * @returns {} 
         */
        $scope.navigateToSubreport = (event: Event, url) => {
            $scope.mainReportParameters = $scope.parameters;
            $scope.goToMainReport = false;
            this.reloadSSRSReport(event, url, true);
        }


        /**
         * Set subreportId and call SSRS_REPORT_RELOAD event.
         * 
         * @param event - The click button event.   
         * @returns {} 
         */
        $scope.navigateToMainReport = (event: Event) => {
            $scope.goToMainReport = true;
            this.reloadSSRSReport(event, $scope.reportUrl, false);
        }

        /**
         * Set current page value based on user interface.
         * 
         * @param event - The click even.
         * @returns {} 
         */
        $scope.changePage = (event: Event) => {
            event.preventDefault();
            var target = $(event.currentTarget);
            const currentPageNumb = parseInt($scope.currentPage.toString()); // parseInt to avoid string concatenation when increase / decrease page
            switch (target.attr("data-action")) {
                case "first":
                    $scope.currentPage = 1;
                    break;
                case "prev":
                    $scope.currentPage = currentPageNumb - 1;
                    break;
                case "next":
                    $scope.currentPage = currentPageNumb + 1;
                    break;
                case "last":
                    $scope.currentPage = $scope.totalPages;
                    break;
            }
            this.$scope.validatePageAndRefreshReport();
        }

        /**
         * Call SSRS_REPORT_EXPORT event.
         * 
         * @param event - The click button event.
         * @returns {} 
         */
        $scope.generateFile = (event: Event) => {
            event.preventDefault();
            var target = $(event.currentTarget);
            const ext = target.attr("data-action");
            $scope.$root.$broadcast(EventsNames.SSRS_REPORT_EXPORT, [ext]);
        }

        /**
         * Stop of propagation the event to top.
         * 
         * @param event - The click event.
         * @returns {} 
         */
        $scope.stopPropagation = (event: Event) => {
            event.stopPropagation();
        }

        /**
         * Find text in the raport.
         * 
         * @returns {} 
         */
        $scope.findText = () => {
            const searchElement = angular.element("#ReportViewerSearchText");
            $scope.clearSearch();
            const text = searchElement.val();
            if (typeof (text) !== "undefined" && _.isString(text) && text.length >= 3) {
                $scope.searchText = text;
                $scope.$root.$broadcast(EventsNames.SSRS_FIND_TEXT);
            }
            else {
                searchElement.val("");
                CommonHelper.openInfoPopup(i18n("Common", this.$scope.titleSearch), "warning");
            }
        }

        /**
         * Unmark text in ssrs raport.
         * 
         * @returns {} 
         */
        $scope.clearSearch = () => {
            if (this.$scope.oldSearchText != null && this.$scope.oldSearchText !== "") {
                this.$scope.ssrsReport = this.$scope.ssrsReport.replace(/<\/?mark>/g, "");
            }
        }

        /**
         * Clear the search input.
         * 
         * @returns {} 
         */
        $scope.clearInput = () => {
            const searchElement = angular.element("#ReportViewerSearchText");
            if (searchElement.val.length !== 0) {
                searchElement.val("");
                this.$scope.titleSearch = i18n("Common", "SearchPhraseIsTooShort");
            }
        }

        /**
         * Sets visbility of ReportViewerSearchText input based on search text length. 
         * 
         * @returns {} 
         */
        $scope.showOrHideToolTip = () => {
            const searchTextBox = angular.element("#ReportViewerSearchText");
            const text = searchTextBox.val();

            if (_.isString(text)) {
                $scope.showToolTip = text.length < 3;

                if ($scope.showToolTip) {
                    this.$scope.titleSearch = i18n("Common", "SearchPhraseIsTooShort");
                }
                else {
                    this.$scope.titleSearch = i18n("Common", "Search");
                }
            }
        };

        /**
         * Close the modal window.
         * 
         * @param event - The click event.
         * @returns {} 
         */
        $scope.closeModal = (event: Event) => {
            event.preventDefault();
            $scope.id = null;
            $scope.ssrsReport = null;
            $scope.ssrsToolbar = null;
            $scope.currentPage = 1;
            $scope.totalPages = null;
            $scope.searchText = "";
            $scope.subreportId = null;
            $scope.parameters.splice(0, $scope.parameters.length);
            $scope.raportName = null;
            $scope.ssrsParametersHtml = null;
            $scope.isSubraport = false;
            $scope.goToMainReport = false;
            angular.element(jQuery("#ssrsModal")).hide();
        };

        /**
         * The SSRS_REPORT_EXPORT event handler.
         */
        $scope.$on(EventsNames.SSRS_REPORT_EXPORT, (event: ng.IAngularEvent, ...args: any[]) => {
            this.$scope.$root.$broadcast("showLoadingIndicator");
            this.exportSsrsReport(args[0]);
            this.$scope.$root.$broadcast("hideLoadingIndicator");
        });

        /**
         * The SSRS_REPORT_PRINT event handler.
         */
        $scope.$on(EventsNames.SSRS_REPORT_PRINT, (event: ng.IAngularEvent, ...args: any[]) => {
            this.$scope.$root.$broadcast("showLoadingIndicator");
            this.printSsrsReport($scope.printWindow);
            this.$scope.$root.$broadcast("hideLoadingIndicator");
        });

        /**
         * The SSRS_FIND_TEXT event handler.
         */
        $scope.$on(EventsNames.SSRS_FIND_TEXT, (event: ng.IAngularEvent, ...args: any[]) => {
            this.$scope.$root.$broadcast("showLoadingIndicator");
            this.searchTextInssrs();
            this.$scope.$root.$broadcast("hideLoadingIndicator");
        });

        /**
         * The SSRS_REPORT_RELOAD event handler.
         */
        $scope.$on(EventsNames.SSRS_REPORT_RELOAD, (event: ng.IAngularEvent, ...args: any[]) => {
            this.$scope.$root.$broadcast("showLoadingIndicator");

            if (this.$scope.currentPage < 1)
                this.$scope.currentPage = 1;

            this.getSsrsReport();

            this.$scope.$root.$broadcast("hideLoadingIndicator");
        });

        /**
         * The REPORT_GENERATE event handler.
         */
        $scope.$on(EventsNames.REPORT_GENERATE, (event: ng.IAngularEvent, ...args: any[]) => {
            const report: OpReport = args[0];

            this.$scope.subreportId = "";
            this.$scope.goToMainReport = false;
            this.$scope.isSubraport = false;
            this.$scope.id = report.idReport;

            if (report.idReportType === ReportType.Server_reporting_services) {
                this.getSsrsReport();
                this.setCorrectLanguage();
            } else if (report.idReportType === ReportType.Predefined_report_based_on_stored_procedure) {
                if (this.$scope.storedProcedureReportPopupForm != null) {
                    this.$scope.storedProcedureReportPopupForm.showPopup(report.idReport)
                }
            } else {
                this.getStandardReport($scope, this.$scope.id);
            }
        });

        /**
         * Create new Date object base on timestamp in string.
         * 
         * @param value 
         * @returns {Date obcjet} 
         */
        this.$scope.formatDate = (value: string) => {
            return new Date(value).getTime();
        }
    }

    /**
    * Set subreportId and call SSRS_REPORT_RELOAD event.
    * 
    * @param event - The click button event.   
    * @param url - The url of subreport or main report in base64.
    * @param isSubraport - The boolean value which means is or not is subraport.
    * @returns {} 
    */
    reloadSSRSReport(event: Event, url: string, isSubraport: boolean) {
        event.preventDefault();
        this.$scope.subreportId = url;
        this.$scope.isSubraport = isSubraport;
        this.$scope.currentPage = 1;
        this.$scope.searchText = "";
        this.setCorrectParams();
        this.$scope.$root.$broadcast(EventsNames.SSRS_REPORT_RELOAD);
    }

    /**
    * Set params to display report.
    *
    */
    setCorrectParams() {
        if (!this.$scope.isSubraport && this.$scope.goToMainReport) {
            this.$scope.parameters = this.$scope.mainReportParameters;
        }
    }

    /**
    * Set [selected_values] of multiple-valued [param] based on user interface.
    *
    * @param param - Current report parameter info object.  
    * @param changedValue - Changed value 
    * @returns {}
    * 
    */
    checkCorrectParameter(param: ReportParameterInfo, changedValue: string) {
        const idx = this.$scope.parameters.indexOf(param);
        const sel = this.$scope.parameters[idx].selectedValues;
        if (param.multiValue === false) {
            sel.splice(0, sel.length);
            sel.push(changedValue);
        } else {
            const selIndex = sel.indexOf(changedValue);
            if (selIndex === -1) {
                sel.push(changedValue);
            } else {
                sel.splice(selIndex, 1);
            }
        }
    }

    /**
     * Set default values of the scope properties.
     *  
     */
    setDefaultValuesOfProperties() {
        this.$scope.currentPage = 1;
        this.$scope.showToolTip = true;
        this.$scope.format = Format;
        this.$scope.mParameterTypeEnum = ParameterTypeEnum;
    }

    /**
     * Set correct version of language for label.
     *  
     */
    setCorrectLanguage() {
        this.$scope.titleRefresh = i18n("Common", "Refresh");
        this.$scope.titleRefreshParams = i18n("Common", "RefreshParameters");
        this.$scope.titleClose = i18n("Common", "Close");
        this.$scope.titleExport = i18n("Common", "ExportSsrs");
        this.$scope.titlePrint = i18n("Common", "Print");
        this.$scope.titleFirst = i18n("Common", "FirstPage");
        this.$scope.titleLast = i18n("Common", "LastPage");
        this.$scope.titleNext = i18n("Common", "NextPage");
        this.$scope.titlePrevious = i18n("Common", "PreviousPage");
        this.$scope.titleSearch = i18n("Common", "SearchPhraseIsTooShort");
        this.$scope.checkAll = i18n("Common", "CheckAll");
        this.$scope.titleBackToMain = i18n("Common", "BackToMainReport");
        this.$scope.viewReport = i18n("Common", "ViewReport");
        this.$scope.chooseOption = i18n("Common", "ChooseOption");
    }

    /**
     * Open new print window with report in pdf format.
     * 
     * @param printWindow
     */
    printSsrsReport(printWindow: Window) {
        const req = this.createRequest(Format.Pdf);

        this.api.ssrsreport.generateReport(req).then((result: ReportExportResult) => {

            const blob = this.data2Blob(result.reportData, true, result.mimeType);
            const isChrome = this.checkBrowser(/chrome/);
            const isIe = this.checkBrowser(/trident/);
            const name = this.getRaportName(result);

            if (isIe === false) {
                const url = window.URL.createObjectURL(blob);
                printWindow.location.href = url;
            };

            $(printWindow).ready(() => {
                if (isChrome) {
                    printWindow.open();
                } else if (isIe) {
                    printWindow.close();
                    window.navigator.msSaveOrOpenBlob(blob, name);
                }
            });
        }
        ).finally(() => {
            this.$scope.$root.$broadcast("hideLoadingIndicator");
        });
    }

    /**
     * Export report to the format passed by argument.
     *  
     * @param format  - The format enum value of the report.
     * @returns {} 
     */
    exportSsrsReport(format: string) {
        const req = this.createRequest(format[0]);

        this.api.ssrsreport.generateReport(req).then((result: ReportExportResult) => {
            this.$scope.$root.$broadcast("showLoadingIndicator");
            if (typeof (result) !== "undefined") {
                const reportExport = this.data2Blob(result.reportData, true, result.mimeType);
                const name = this.getRaportName(result);

                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(reportExport, name);
                }
                else {
                    const a = document.createElement("a");
                    a.id = "exportLink";
                    a.style.display = "none";
                    document.body.appendChild(a);
                    const url = window.URL.createObjectURL(reportExport);
                    a.href = url;
                    a.setAttribute("download", name);
                    a.click();
                    window.URL.revokeObjectURL(url);
                    angular.element(jQuery("#exportLink")).remove();
                }
            }
            else CommonHelper.openInfoPopup(i18n("Common", "ReportGenerateProblem"), "error", 5000);
        }
        ).finally(() => {
            this.$scope.$root.$broadcast("hideLoadingIndicator");
        });
    }

    /**
     * Get name of the report.
     * 
     * @param result - The report.
     * @returns { Name of report with the concated execution date and extension.}
     */
    getRaportName(result): string {
        const extension = this.getExtension(result.formatType);
        const exdate = new Date().toISOString().slice(0, 10).toString();
        let name = "report";

        if (typeof (result.name) !== "undefined") {
            const find = " ";
            const re = new RegExp(find, "g");
            name = result.name.replace(re, "_").toLowerCase();
        }
        return name + "_" + exdate + "." + extension;
    }


    /**
     * Check the current browser.
     * 
     * @param browsName - name of browser to check.
     * @returns { True if it is the browser from the param and false if not.}
     */
    checkBrowser(browsName): boolean {
        const ua = navigator.userAgent.toLowerCase();
        return browsName.test(ua);
    }

    /**
     * Get the extension of format type.
     * 
     * @param formatType - The enum to check correck type.
     * @returns { Extension for passed format.}
     */
    getExtension(formatType) {
        switch (formatType) {
            case Format.Undefined: return "txt";
            case Format.Rgdi: return "gdi";
            case Format.Xml: return "xml";
            case Format.Csv: return "csv";
            case Format.Atom: return "atomsvc";
            case Format.Pdf: return "pdf";
            case Format.Html40: return "html";
            case Format.Mhtml: return "mhtml";
            case Format.Excel: return "xls";
            case Format.ExcelOpenXml: return "xlsx";
            case Format.Rpl: return "rpl";
            case Format.Word: return "doc";
            case Format.WordOpenXml: return "docx";
            case Format.Tiff: return "tif";
            case Format.Jpeg: return "jpeg";
            case Format.Gif: return "gif";
            case Format.Png: return "png";
            case Format.Bmp: return "bmp";
            default: return "txt";
        }
    }

    /**
     *  Serching text in ssrs raport.
     */
    searchTextInssrs() {
        const req = this.createRequest(Format.Html40);
        req.searchText = this.$scope.searchText;

        this.api.ssrsreport.findText(req).then((result: string) => {
            this.$scope.$root.$broadcast("showLoadingIndicator");
            result = result[0] + result[1] + result[2] + result[3];
            if (result === "true") {
                this.$scope.ssrsReport = this.$scope.ssrsReport.replace(new RegExp("&#211;", "gi"), "Ó");
                this.$scope.ssrsReport = this.$scope.ssrsReport.replace(new RegExp("&#243;", "gi"), "ó");

                this.highlightText();
                this.$scope.oldSearchText = this.$scope.searchText;
            }
            else {
                CommonHelper.openInfoPopup(i18n("Common", "NotFoundRecords"), "error");
            }
        }
        ).finally(() => {
            this.$scope.$root.$broadcast("hideLoadingIndicator");
        });
    }

    /**
     * Highlight text in report.
     *
     * This function is adding <mark> tag to searched text, when searched text is not in img tag.
     */
    highlightText() {
        let idx = 0;
        let parentTagIdx = 0;
        let ssrsText = this.$scope.ssrsReport;
        const searchText = this.$scope.searchText;
        let idxMagnifier = 1;

        idx = ssrsText.toLowerCase().indexOf(searchText.toLowerCase(), idx);

        while (idx !== -1) {
            for (let i = idx; i > 0; i--) {
                if (ssrsText[i] === "<") {
                    parentTagIdx = i;
                    break;
                }
            }

            const tagText = ssrsText.slice(parentTagIdx, parentTagIdx + 6);

            idxMagnifier = 1;

            const imgIdx = tagText.toLowerCase().indexOf("img");
            const metaIdx = tagText.toLowerCase().indexOf("meta");

            if (imgIdx === -1 && metaIdx === -1) {
                const startPart = ssrsText.slice(0, idx);
                const endPart = ssrsText.slice(idx + searchText.length);
                const middlePart = `<mark>${ssrsText.slice(idx, idx + searchText.length)}</mark>`;

                idxMagnifier = 7;

                ssrsText = startPart + middlePart + endPart;
            }

            idx = ssrsText.toLowerCase().indexOf(searchText.toLowerCase(), idx + idxMagnifier);
        }

        this.$scope.ssrsReport = ssrsText;
    }


    /**
     * Transform data to blob.
     * 
     * @param data - Data to transorm to blob.
     * @param isBase64 - Flag to check if data is base64.
     * @param mimeType - It is mine type.
     * @returns { Blob. }
     */
    data2Blob(data: string, isBase64: boolean = true, mimeType = "application/pdf") {
        const chars = isBase64 ? atob(data) : data;

        const bytes = new Array(chars.length);
        for (let i = 0; i < chars.length; i++) {
            bytes[i] = chars.charCodeAt(i);
        }

        return new Blob([new Uint8Array(bytes)], ({ type: mimeType }) as any);
    }

    /**
     * Get teh ssrs raport.
     */
    getSsrsReport() {
        const req = this.createRequest(Format.Html40);
        this.$scope.$root.$broadcast("showLoadingIndicator");
        this.api.ssrsreport.generateReport(req).then((result: ReportExportResult) => {
            if (typeof (result) !== "undefined") {
                this.$scope.ssrsReport = this.b64DecodeUnicode(result.reportData);
                this.$scope.reportUrl = result.reportUrl;
                this.$scope.currentPage = result.currentPage;
                this.$scope.totalPages = result.totalPages;
                this.$scope.parameters = result.parameters;
                this.$scope.raportName = result.name;

                this.setCorrectParams();

                this.validateTypesOfExport(result.listOfTypesToDisplay);
            }
            else {
                CommonHelper.openInfoPopup(i18n("Common", "ReportGenerateProblem"), "error", 5000);
            }
        }

        ).finally(() => {
            this.$scope.$root.$broadcast("hideLoadingIndicator");
            angular.element(jQuery("#ssrsModal")).show();
        });
    }

    /**
     * Decode unicode from base 64.
     * 
     * @param str - The string to decode.
     * @returns { Unicode }
     */
    b64DecodeUnicode(str) {
        return decodeURIComponent(atob(str).split("").map(c => `%${(`00${c.charCodeAt(0).toString(16)}`).slice(-2)}`).join(""));
    }

    /**
     * Check the available types of export.
     * 
     * @param listOfTypesToDisplay - List of types to display.
     */
    validateTypesOfExport(listOfTypesToDisplay: Format[]) {
        this.$scope.formatCsv = !(listOfTypesToDisplay.indexOf(Format.Csv) === -1);
        this.$scope.formatExcel = !(listOfTypesToDisplay.indexOf(Format.Excel) === -1);
        this.$scope.formatMhtml = !(listOfTypesToDisplay.indexOf(Format.Mhtml) === -1);
        this.$scope.formatPdf = !(listOfTypesToDisplay.indexOf(Format.Pdf) === -1);
        this.$scope.formatTiff = !(listOfTypesToDisplay.indexOf(Format.Tiff) === -1);
        this.$scope.formatWord = !(listOfTypesToDisplay.indexOf(Format.Word) === -1);
        this.$scope.formatXml = !(listOfTypesToDisplay.indexOf(Format.Xml) === -1);
    }

    /**
     * Get standart raport form server.
     * 
     * @param $scope - The scope.
     * @param id - The id raport.
     */
    getStandardReport($scope, id) {
        this.api.report.generateReport(id).then((result: GeneratedReportModel) => {
            $scope.$root.$broadcast("showLoadingIndicator");
            if (result.resultString.toLowerCase() !== false.toString()) {
                CommonHelper.openInfoPopup(i18n("Common", "ReportGenerated"));
                if (result.reportType === CommonHelper.reportType.serverReportingServices) {
                    if (window["config"].REPORT_VIEWER) {
                        $scope.$root.$broadcast(EventsNames.SSRS_REPORT_GENERATE,
                            this.dataGrid.getSelectedRowsData()[0][CommonHelper.idField]);
                    } else {
                        window.open(result.resultString, "_blank");
                    }
                }
            }
            else CommonHelper.openInfoPopup(i18n("Common", "ReportGenerateProblem"), "error", 5000);
        }
        ).finally(() => {
            $scope.$root.$broadcast("hideLoadingIndicator");
        });
    }

    /**
     * Creates request for report.
     * 
     * @param format - The format to create new report.
     */
    createRequest(format) {
        const req = new SsrsReportRequestModel();
        req.id = this.$scope.id;
        req.currentPage = this.$scope.currentPage;
        req.subreportId = this.$scope.subreportId;
        req.format = format;
        const params: { [key: string]: string[]; } = {};

        const parameters = this.$scope.parameters;
        for (let idx in parameters) {
            if (parameters.hasOwnProperty(idx)) {
                const parmeter = parameters[idx];
                params[parmeter.name] = parmeter.selectedValues;
            }
        }

        req.parameters = params;

        return req;
    }

    /**
     * Show report popup.
     */
    showReportPopup = () => {
        var selectedRows = this.dataGrid.getSelectedRowsData();
        var statusIds = [];
        var ids = [];
        selectedRows.forEach(row => {
            ids.push(row["id"]);
            statusIds.push(row["statusId"]);
        });
        this.$scope.$broadcast(EventsNames.OPEN_REPORT_STATUS_CHANGE_POPUP, ids, statusIds);
    };

    // Events

    private onInitialized(e: any, grid: GridController<OpReport>) {
        this.setGridId(e.tableId);

        this.grid = grid
        this.dataGrid = e.component;
    }

    private onAdd(): void {
        const createEditInitParams: CreateEditInitParams = {
            moduleName: this.moduleName,
            idReferenceType: this.referenceType,
            createEditSelectedTabType: Enums.SimaxCreateEditSelectedTabType.BaseParameters,
            groupReferenceType: null,
            groupReferenceValue: null,
            referenceObjectId: 0,
            referenceObject: null,
            sections: null,
            useBusinessObjects: true
        }

        this.$scope.$broadcast(EventsNames.INITIALIZE_CREATE_EDIT_POPUP, createEditInitParams)
    }

    private onEdit(): void {
        if (this.grid.selectedCount == 1) {
            const createEditInitParams: CreateEditInitParams = {
                moduleName: this.moduleName,
                idReferenceType: this.referenceType,
                createEditSelectedTabType: Enums.SimaxCreateEditSelectedTabType.BaseParameters,
                groupReferenceType: null,
                groupReferenceValue: null,
                referenceObjectId: this.grid.selectedItemId,
                referenceObject: null,
                sections: null,
                useBusinessObjects: true
            }

            this.$scope.$broadcast(EventsNames.INITIALIZE_CREATE_EDIT_POPUP, createEditInitParams)
        } else {
            const columnCount = this.grid.dxGrid.columnCount()
            const columns = []

            for (let i = 0; i < columnCount; i++) {
                columns.push(this.grid.dxGrid.columnOption(i));
            }

            const bulkEditInitParams: BulkEditInitParams = {
                moduleName: this.moduleName,
                idReferenceType: this.referenceType,
                groupReferenceType: null,
                groupReferenceValue: null,
                selectedGridRows: angular.copy(this.grid.selectedGridItems),
                gridColumns: columns,
                section: null,
                useBusinessObjects: true
            }

            this.$scope.$root.$broadcast(EventsNames.INITIALIZE_BULK_EDIT_POPUP, bulkEditInitParams)
        }
    }

    private onShowDetails(e: any): void {
        const openDetailsOptions: DetailsOptions = {
            hasPermission: true,
            idReferenceType: this.referenceType,
            moduleName: this.moduleName,
            pageItemsIds: this.grid.pageItemsIds,
            referenceObjectId: this.grid.selectedItemId,
        }

        this.showDetails(e, openDetailsOptions)
    }

    private onDelete(): void {
        this.$scope.$broadcast(
            EventsNames.OPEN_CONFIRMATION_POPUP + this.$scope.popupId,
            LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__CONFIRM_DELETE, this.moduleName)
        )
    }

    private onDeleted(): void {
        this.grid.dxGrid.refresh()
    }

    private onConfirmDelete(): void {
        ReportHelper
            .deleteReport(this.userSession.getDataProvider(), this.grid.selectedItemId, this.moduleName)
            .then(() => {
                this.$scope.$root.$broadcast(EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__DELETED, this.moduleName))
            })
            .fail((error: any) => {
                this.logger.log(error)
            })
    }

    private onReportGenerate(): void {
        this.$scope.$broadcast(EventsNames.REPORT_GENERATE, this.grid.selectedItem);
    }

    // Events End


    // Setup

    private getContextMenuItems(isTouchScreen: boolean = false): any[] {
        const items = this.gridContextMenuService.getContextMenuItemsByReferenceType(Enums.ReferenceType.IdReport, {
            idReferenceTypes: this.grid.selectedItemsIds,
            onEdit: () => this.onEdit(),
            onReportGenerate: () => this.onReportGenerate()
        })

        return this.mergeWithDefaultItems(isTouchScreen, items)
    }


    private setConfirmationsOptions(): void {
        this.$scope.deleteConfirmationOptions = {
            title: LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__DELETING, this.moduleName),

            onConfirmed: () => this.onConfirmDelete()
        }
    }

    private getGridButtonsOptions(): ButtonsOptions {
        return {
            enabled: true,

            // exportPermissions: "['" + Activity.REPORTS_EXPORT + "']",
            // importPermissions: "['" + Activity.REPORTS_IMPORT + "']",
            addPermissions: this.userSession.getLoggedOperator().hasPermission(Activity.REPORT_ADD) ? "['" + Activity[Activity.REPORT_ADD] + "']" : null,
            deletePermissions: this.userSession.getLoggedOperator().hasPermission(Activity.REPORT_DEL) ? "['" + Activity[Activity.REPORT_DEL] + "']" : null,
            editPermissions: this.userSession.getLoggedOperator().hasPermission(Activity.REPORT_EDIT) ? "['" + Activity[Activity.REPORT_EDIT] + "']" : null,
            generateReportPermissions: this.userSession.getLoggedOperator().hasPermission(Activity.REPORT_GENERATE_OP) ? "['" + Permissions.REPORT_GENERATE + "']" : null,
            saveColumnSettingsPermissions: this.userSession.getLoggedOperator().hasPermission(Activity.WEBSIMAX_MODULE_VIEW_COLUMN_DEFINITION_OP) ? "['" + Activity[Activity.WEBSIMAX_MODULE_VIEW_COLUMN_DEFINITION_OP] + "']" : null,
            showDetailsPermissions: this.userSession.getLoggedOperator().hasPermission(Activity.REPORTS_LIST) ? "['" + Activity[Activity.REPORTS_LIST] + "']" : null,

            onAddClick: () => this.onAdd(),
            onDeleteClick: () => this.onDelete(),
            onEditClick: () => this.onEdit(),
            onGenerateReportClick: () => this.onReportGenerate(),
            onShowClick: (e: any) => this.onShowDetails(e),
        }
    }

    private setEvents(): void {
        this.$scope.$on(
            EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__DELETED, this.moduleName),
            (event: ng.IAngularEvent, ...args: any[]) => this.onDeleted()
        )

        this.$scope.showDetails = (e: any) => this.onShowDetails(e)
    }

    private setMainGridOptions(): void {
        $.when(
            this.userSession
                .getDataProvider().System
                .getRequestColumnInfo(Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__GRID_PARAMS, this.moduleName),
            this.userSession
                .getDataProvider().System
                .getRequestColumnInfo(Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__DEFAULT_GRID_PARAMS, this.moduleName)
        )
            .then((columns: ColumnModel[], defaultColumns: ColumnModel[]) => {
                this.$scope.mainGridOptions = {
                    addCustomFilters: true,
                    buttonsOptions: this.getGridButtonsOptions(),
                    columnsDictionary: columns,
                    defaultColumnsDictionary: defaultColumns,
                    exportMethod: 'reports',
                    idReferenceType: Enums.ReferenceType.IdReport,
                    localStorageVarForSavedEntity: CommonHelper.localStorageVarForSavedEntity.reportSaved,
                    name: 'ReportsGrid',
                    preExecuteClearFilter: this.preExecuteGridClearFilter,
                    referenceId: this.referenceType,
                    type: GridTypes.MAIN,

                    allowColumnReordering: !this.userSession
                        .getLoggedOperator()
                        .hasPermission(Activity.WEBSIMAX_COLUMN_REORDER_DISALLOWED, Enums.UIObjectProperties.ReportModuleMainGrid),

                    getDataSourceMethod: this.userSession
                        .getDataProvider().Report.getReportFilter,

                    importOptions: {
                        dictionaryMethodName: "getReportsEditFields",
                        popupName: i18n("Popup", "ImportReports"),
                        requestMethodType: "report",
                        referenceType: CommonHelper.IdReport,
                        moduleName: this.moduleName,
                        columnsReorderingDisabled: this.userSession
                            .getLoggedOperator()
                            .hasPermission(Activity.WEBSIMAX_COLUMN_REORDER_DISALLOWED, Enums.UIObjectProperties.ReportModuleMainGrid),
                    },

                    contextMenuItems: (isTouchScreen: boolean = false) => this.getContextMenuItems(isTouchScreen),
                    onInitialized: (e: any, grid: GridController<OpReport>) => this.onInitialized(e, grid),
                    onDataReady: (data: any) => this.onDataReady(data),
                    onRowDoubleClick: (e: any) => this.onShowDetails(e),
                }
            })
    }

    // Setup End
}